import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#E23531",
        fadein: "#df692d",
        secondary: "#E0642E",
        dialogBtn: "#FFFFFF",
        buttons: "#df692d",
        accent: "#8c9eff",
        error: "#b71c1c"
      }
    }
  }
});
